import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'

export const LoadingPage: TOC<unknown> = <template>
  <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} />
</template>

export default RouteTemplate(LoadingPage)
